import script from "./EmployeeHandbookSignOffFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeHandbookSignOffFormView.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeHandbookSignOffFormView.vue?vue&type=style&index=0&id=0cc38ea9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc38ea9"]])

export default __exports__